import React from 'react'
import { Dialog, Heading, Modal as AriaModal, ModalOverlay } from 'react-aria-components'

interface ModalProps {
  open: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
  footer?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
}

const SIZE_CLASSES: Record<NonNullable<ModalProps['size']>, string> = {
  sm: 'max-w-md',
  md: 'max-w-2xl',
  lg: 'max-w-4xl',
}

export function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  size = 'md',
}: ModalProps) {
  return (
    <ModalOverlay
      isOpen={open}
      isDismissable
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose()
      }}
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-8 bg-gray-900/40"
    >
      <AriaModal
        className={`w-full ${SIZE_CLASSES[size]} bg-white rounded-2xl shadow-xl border border-gray-200`}
      >
        <Dialog className="outline-none">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <Heading
              slot="title"
              className="text-sm font-semibold text-gray-900 uppercase tracking-wide"
            >
              {title}
            </Heading>
            <button
              onClick={onClose}
              className="text-xs text-gray-500 hover:text-gray-700 cursor-pointer"
            >
              Close
            </button>
          </div>
          <div className="px-6 py-5">{children}</div>
          {footer && (
            <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-2xl">
              {footer}
            </div>
          )}
        </Dialog>
      </AriaModal>
    </ModalOverlay>
  )
}
